import {
	forIn as _forIn,
	pickBy as _pickBy,
	minBy as _minBy,
	maxBy as _maxBy,
} from 'lodash';
import moment from 'moment/moment';

const DEFAULT_MIN = -200;
const DEFAULT_MAX = 200;

const getData = (attributes, rangeType) => {
	const dAttributes = _pickBy(attributes, (value, key) => /^d_/.test(key)); // show d_attribute in chart for now
	let points = [];
	_forIn(dAttributes, (value, key) => {
		const dateString = key.split('_')[1];
		points.push({
			key,
			date: moment(dateString).toISOString(true),
			value,
		});
	});

	let max = _maxBy(points, point => point.value)?.value;
	let min = _minBy(points, point => point.value)?.value;

	if (rangeType === 'fixed') {
		max = DEFAULT_MAX;
		min = DEFAULT_MIN;
	} else if (rangeType === 'dynamic') {
		const diff = Math.abs(max - min);
		if (diff < 50) {
			const addition = Math.floor((100 - diff) / 4);
			min -= addition;
			max += addition;
		}
	}

	return [points, min, max];
};

export default getData;
